<template>
  <div>
    <div style="width: 100vw; background-color: #f9f9f9; display: flex; flex-direction: row; justify-content: center; align-items: center;">
      <div 
        :style="'width: '+($store.getters.getScreenWidth < 1400 ? '98%' : '90%')+'; height: '+($store.getters.getScreenWidth>=650 ? '400px' : '')+'; padding-bottom: '+($store.getters.getScreenWidth>=650 ? '' : '40px')+'; padd max-width: 1920px; margin-top: 80px; display: flex; flex-direction: '+($store.getters.getScreenWidth>=650 ? 'row' : 'column')+'; justify-content: space-between; align-items: space-between;'">
        <div :style="'display: flex; flex-direction: column; width: '+($store.getters.getScreenWidth>=650 ? '50%' : '100%')+'; text-align: left;'">
          <span :style="'font-size: '+$store.getters.getFontSizes.f54+'; font-weight: 500;'">
              Get the most from
          </span>
          <span :style="'font-size: '+$store.getters.getFontSizes.f54+'; font-weight: 500;'">
              Easy Tailor App
          </span>
          <span :style="'font-size: '+$store.getters.getFontSizes.f18+'; margin-top: 30px;'">
              With its simple UI and functionality, EasyTailorApp makes it easier to meet business goals in the frantic world of tailoring. Whatever your management requires, we have it.
          </span>
          <div @click="$emit('toggleSignup')" style="cursor: pointer; margin-top: 30px; padding: 10px; width: 220px; border-radius: 10px; text-align: center; background-color: #000; color: white;">
              <span :style="'font-size: '+$store.getters.getFontSizes.f13+''">
                sign up for a 15-day free trial
              </span>
          </div>
          <img v-if="$store.getters.getScreenWidth<650" src="https://etacdn.b-cdn.net/new-website/apple-android.png" style="width: 150px" alt="">
        </div>
        <div v-if="$store.getters.getScreenWidth>=650" :style="'width: '+($store.getters.getScreenWidth>=650 ? '50%' : '100%')+'; text-align: right;'">
          <img src="https://etacdn.b-cdn.net/new-website/hero-image.png" :width="'95%'" alt="easytailorapp">
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>

export default {
    
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home/Row1.vue